import {useMemo, useState} from 'react'
import {ID, KTSVG} from '../../_metronic/helpers'
import {DeleteModal} from '../table/DeleteModal'

type Props = {
  model: string
  title: string
  setItemIdForUpdate: (id: ID) => void
  setItemIdToView: (id: ID) => void
  itemIdToView: ID
  itemIdForUpdate: ID
  deleteAction?: (id: ID) => Promise<void>
  refetch?: () => void
}
export const Header = (props: Props) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)

  const openEditModal = () => {
    props.setItemIdForUpdate(props.itemIdToView)
    props.setItemIdToView(undefined)
  }

  const openViewModal = () => {
    props.setItemIdToView(props.itemIdForUpdate)
    props.setItemIdForUpdate(undefined)
  }

  const idExists = useMemo(() => {
    return !!props.itemIdToView || !!props.itemIdForUpdate
  }, [props.itemIdToView, props.itemIdForUpdate])

  return (
    <>
      <div className='flex items-center justify-between px-6 py-4 border-b border-gray-200'>
        <h2 className='text-lg font-semibold'>
          {props.itemIdToView ? 'View' : props.itemIdForUpdate ? 'Edit' : 'Add'} {props.title}
        </h2>
        <div className='flex items-center space-x-3'>
          {idExists && !props.itemIdForUpdate && (
            <>
             
                <button
                  onClick={openEditModal}
                  className='text-blue-600 hover:text-blue-800'
                  title='Edit'
                >
                  <i className='fa-regular fa-pen-to-square text-xl'></i>
                </button>
          
                <button
                  onClick={() => setShowDeleteConfirm(true)}
                  className='text-red-600 hover:text-red-800'
                  title='Delete'
                >
                  <i className='fa-regular fa-trash-can text-xl'></i>
                </button>
       
            </>
          )}

          {idExists && !props.itemIdToView && (
            <button
              onClick={openViewModal}
              className='text-gray-600 hover:text-gray-800'
              title='View'
            >
              <i className='fa-regular fa-eye text-xl'></i>
            </button>
          )}

          <button
            onClick={() =>
              props.itemIdToView
                ? props.setItemIdToView(undefined)
                : props.setItemIdForUpdate(undefined)
            }
            className='text-gray-600 hover:text-gray-800'
            title='Close'
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='w-5 h-5' />
          </button>
        </div>
      </div>

      <DeleteModal
        showDeleteConfirm={showDeleteConfirm}
        setShowDeleteConfirm={setShowDeleteConfirm}
        deleteAction={props.deleteAction}
        refetch={() => {
          props.setItemIdToView(undefined)
          props.refetch?.()
        }}
        id={props.itemIdToView}
      />
    </>
  )
}
